export default __webpack_public_path__ + "static/media/offer-2-90d3534e1ad62a8b8a977f1290e61e9f.1d274241.png";